export enum EventsQueryKeys {
	getEvents = 'getEvents',
	getEventById = 'getEventById',
	getTurnoverEvents = 'getTurnoverEvents',
	getTurnoverEventById = 'getTurnoverEventById',
	getTurnoverEventClaims = 'getTurnoverEventClaims',
}

export enum EventsMutationKeys {
	createEvent = 'createEvent',
	updateEvent = 'updateEvent',
	deleteEvent = 'deleteEvent',
	createTurnoverEvent = 'createTurnoverEvent',
	updateTurnoverEvent = 'updateTurnoverEvent',
	updateTurnoverEventStatus = 'updateTurnoverEventStatus',
	deleteTurnoverEvent = 'deleteTurnoverEvent',
}
